import type { UserBannerImageAttributes } from 'hb-builder/components/BuilderComponents/block/UserBanner/types/UserBannerChildren';
import DisplayOption from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayOption';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

const Image = ({
  item,
  onChange,
}: Omit<
  ComponentSettingsTab<UserBannerImageAttributes>,
  'defaultAttributes'
>) => (
  <>
    <DisplayOption
      title={__('Display image')}
      item={item}
      onChange={onChange}
    />
    <InputTitle label={__('Alternative text')} />
    <TextSetting
      item={item}
      onChange={onChange}
      placeholder={__('Enter alternative text')}
      description={__("This will appear if the image can't be displayed")}
      settingKey="attributes.alt"
      width="100%"
    />
  </>
);

export default Image;
